export default function ArticleCTA() {
  return (
    <section className="relative w-full min-h-[450px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20natural%20light%20lifestyle%20photography%20of%20fashion%20items%20including%20a%20pair%20of%20white%20sneakers%20and%20a%20folded%20knit%20sweater%20on%20a%20light%20wooden%20console%20table%20with%20a%20ceramic%20vase%20of%20dried%20pampas%20grass%20soft%20cream%20and%20warm%20beige%20tones%20cozy%20aspirational%20home%20aesthetic%20editorial%20style%20photography%20with%20gentle%20shadows%20and%20organic%20serene%20atmosphere&width=1920&height=1080&seq=pandabuy-article-cta-existing-v3&orientation=landscape"
          alt="Start Shopping with Pandabuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white tracking-wide">
          READY TO START SHOPPING?
        </h2>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/80 leading-relaxed max-w-xl mx-auto">
          Put your Pandabuy Spreadsheet knowledge into action.
          <br />
          Browse 1000+ curated listings right now.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 md:mt-10 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-all duration-200 cursor-pointer group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500">
            <i className="ri-shopping-bag-3-line text-white text-sm"></i>
          </span>
          <span className="text-sm font-bold tracking-wide">BUY IT NOW</span>
          <i className="ri-arrow-right-up-line text-white text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}